module.exports = __webpack_public_path__ + "static/media/FoxIntroductionPage.dfb92e98.png";